import { useQuery } from "react-query";
import { fetchSummaryData } from "./api";

export function useSummary(filters, options = {}) {
  return useQuery(
    ["fetchSummaryData", filters],
    () => fetchSummaryData(filters),
    {
      staleTime: 60000 * 600,
      cacheTime: 60000 * 6000,
      refetchOnWindowFocus: false,
      ...options,
    }
  );
}
